import { dogService } from "../_services";

const state = {
  all: {
    data: {},
    loading: {},
    updating: {},
    deleting: {},
    error: {}
  },
  current: {
    data: {},
    loading: {},
    updating: {},
    deleting: {},
    error: {}
  },
  breeds: {
    data: null,
    loading: {},
    updating: {},
    deleting: {},
    error: {}
  },
  books: {
    data: {},
    loading: {},
    updating: {},
    deleting: {},
    error: {}
  },
  classes: {
    data: null,
    loading: false,
    updating: {},
    deleting: {},
    error: {}
  }
};

const actions = {
  getAll({ commit }) {
    commit("getAllRequest");
    dogService.getAll().then(
      users => commit("getAllSuccess", users),
      error => commit("getAllFailure", error)
    );
  },

  getById({ commit }, id) {
    commit("getByIdRequest");

    dogService.getById(id).then(
      users => commit("getByIdSuccess", users),
      error => commit("getByIdFailure", error)
    );
  },

  getByUserId({ commit }, id) {
    commit("getByIdRequest");

    dogService.getByUserId(id).then(
      users => commit("getByIdSuccess", users),
      error => commit("getByIdFailure", error)
    );
  },

  update({ dispatch, commit }, dog) {
    commit("updateRequest");

    dogService.update(dog).then(
      dogs => {
        dispatch("alert/success", "Registro actualizado", { root: true });
        commit("updateSuccess", dogs);
        commit("users/updateDogSuccess", dogs, { root: true });
      },
      error => {
        dispatch(
          "alert/error",
          { text: "Se ha producido un error", data: error },
          { root: true }
        );
        commit("updateFailure", error);
      }
    );
  },
  create({ dispatch, commit }, dog) {
    commit("createRequest");

    dogService.create(dog).then(
      dogs => {
        dispatch("alert/success", "Registro creado", { root: true });
        commit("createSuccess", dogs);
        commit("users/createDogSuccess", dogs, { root: true });
      },
      error => {
        dispatch(
          "alert/error",
          { text: "Se ha producido un error", data: error },
          { root: true }
        );
        commit("createFailure", error);
      }
    );
  },

  deleteDog({ dispatch, commit }, id) {
    commit("deleteRequest");

    dogService.delete(id).then(
      dog => {
        dispatch("alert/success", "Registro eliminado", { root: true });
        commit("deleteSuccess");
        commit("users/deleteDogSuccess", id, { root: true });
      },
      error => {
        dispatch(
          "alert/error",
          { text: "Se ha producido un error", data: error },
          { root: true }
        );
        commit("deleteFailure", error);
      }
    );
  },

  /**
   * Breeds
   * @param commit
   */
  getBreeds({ commit }) {
    return new Promise((resolve, reject) => {
      commit("getAllBreedsRequest");
      dogService.getBreeds().then(
        breeds => {
          commit("getAllBreedsSuccess", breeds);
          return resolve(breeds);
        },
        error => commit("getAllBreedsFailure", error)
      );
    });
  },

  /**
   * Books
   * @param commit
   */
  getBooks({ commit }) {
    commit("getAllBooksRequest");
    dogService.getBooks().then(
      books => commit("getAllBooksSuccess", books),
      error => commit("getAllBooksFailure", error)
    );
  },

  getClasses({ commit }) {
    commit("getAllClassesRequest");
    dogService.getClasses().then(
      classes => commit("getAllClassesSuccess", classes),
      error => commit("getAllClassesFailure", error)
    );
  }
};

const mutations = {
  /*
  ALL
   */
  getAllRequest(state) {
    state.all.loading = true;
  },
  getAllSuccess(state, dogs) {
    state.all.loading = false;
    state.all.data = dogs.data;
  },
  getAllFailure(state, error) {
    state.all.loading = false;
    state.all.error = error;
  },
  /*
  CREATE
   */
  createRequest(state) {
    state.current.updating = true;
  },
  createSuccess(state, dogs) {
    state.current.updating = false;
  },
  createFailure(state, error) {
    state.current.updating = false;
    state.current.error = error.data;
  },
  /*
   UPDATE
   */
  updateRequest(state) {
    state.current.updating = true;
  },
  updateSuccess(state, dogs) {
    state.current.updating = false;
    //state.all = { items: users };
  },
  updateFailure(state, error) {
    state.current.updating = false;
    state.current.error = error.data;
  },
  /*
  DELETE
   */
  deleteRequest(state) {
    state.current.deleting = true;
  },
  deleteSuccess(state, dogs) {
    state.current.deleting = false;
  },
  deleteFailure(state, error) {
    state.current.deleting = false;
    state.current.error = error;
  },

  /*
  ById
   */
  getByIdRequest(state) {
    state.current.loading = true;
  },
  getByIdSuccess(state, dog) {
    state.current.loading = false;
    state.current.data = dog.data;
  },
  getByIdFailure(state, error) {
    state.current.loading = false;
    state.current.error = error;
  },
  /*
  Breeds
   */
  getAllBreedsRequest(state) {
    state.breeds.loading = true;
  },
  getAllBreedsSuccess(state, breed) {
    state.breeds.data = breed;
    state.breeds.loading = false;
  },
  getAllBreedsFailure(state, error) {
    state.breeds.error = error.data;
    state.breeds.loading = false;
  },
  /*
  Books
   */
  getAllBooksRequest(state) {
    state.books.loading = true;
  },
  getAllBooksSuccess(state, book) {
    state.books.data = book;
    state.books.loading = false;
  },
  getAllBooksFailure(state, error) {
    state.books.error = error.data;
    state.books.loading = false;
  },
  /*
 Clases
  */
  getAllClassesRequest(state) {
    state.classes.loading = true;
  },
  getAllClassesSuccess(state, classes) {
    state.classes.data = classes.data;
    state.classes.loading = false;
  },
  getAllClassesFailure(state, error) {
    state.classes.error = error.data;
    state.classes.loading = false;
  }
};

const getters = {
  getterBreeds(state) {
    return JSON.parse(JSON.stringify(state.breeds.data));
  },
  getterClasses(state) {
    return JSON.parse(JSON.stringify(state.classes.data));
  }
};

export const dogs = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
